import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const QuizDiagnosticsEmptyState = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Container>
      <ContainerInner>
        <ContentContainer>
          <ContentHeader>{t('quizDiagnostics.emptyState.header')}</ContentHeader>
          <ContentText>{t('quizDiagnostics.emptyState.description')}</ContentText>
        </ContentContainer>
      </ContainerInner>
    </Container>
  )
}

export default QuizDiagnosticsEmptyState

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.backgrounds.main};
  border-radius: ${({ theme }) => theme.shape.borderRadiusBig};
  box-shadow: ${({ theme }) => theme.shadows.darkShadow};
  min-height: 200px;
  padding: 8px;
  width: 100%;
  flex: 1;
`

const ContainerInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.shape.borderRadiusBig};
  background: ${({ theme }) => theme.colors.backgrounds.app};
  height: 100%;
  padding: 16px;
  width: 100%;
`

const ContentContainer = styled.div`
  padding: 16px 0;
  max-width: 520px;
`

const ContentHeader = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 18.4px;
  text-align: left;
`

const ContentText = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 16.1px;
  text-align: left;
  margin-top: 16px;
`
